import { Container } from "reactstrap";
import WorkSessionsList from "./components/list/index";
import { ToastContainer, Breadcrumbs } from "../../components/Common";

const WorkSessionsPage = () => {
    document.title = "Work Sessions";

    return (
        <div className="page-content">
            <Container fluid>
                <Breadcrumbs
                    title="Work Sessions"
                />
                <WorkSessionsList/>
                <ToastContainer />
            </Container>
        </div>
    );
};

export default WorkSessionsPage;
